import { GetterTree } from 'vuex';

export const getters = {
    comments: (state, getters, rootState) => {
        let newComment = Object.assign({}, rootState.selectedDialogGroup.comment);
        if (Object.keys(newComment).length > 0) {          
            state.comments.push(newComment);
        }        
        return state.comments;
    }

};
